<template>
<div class="container-fluid">
	<apps-toolbar ref="appsToolbar" title="Your Published Apps" icon="fa-th-large" v-on:publishedAppSaved="refreshPublishedData"></apps-toolbar>

	<h3 class="mb-3">Your listings</h3>

	<p class="text-muted mb-3">Edit or remove your marketplace listings. Deleting a listing does not uninstall the app from companies that already installed it.</p>

	<table-list
		:records="publishedApps"
		:fields="publishedFields"
		record-name="listing"
		:has-edit="true"
		:has-delete="true"
		delete-endpoint="AddonApp/delete"
		:hide-record-count="true"
		edit-button-text="Edit"
		v-on:edit="editApp"
		v-on:modelChange="refreshPublishedData">
	</table-list>
</div>
</template>

<script>
import AppsToolbar from "./AppsToolbar"

import TableList from "@/components/TableList"

export default {

	name: 'PublishedApps',
	components: {
		AppsToolbar,
		TableList,
	},
	data() {
		return {
			publishedApps: [],
			publishedFields: [
				{ label: "Name", key: "app_name" },
				{ label: "Version", key: "app_version" },
				{ label: "Public", key: "is_public", type: "boolean" },
				{ label: "Published", key: "publish_date_label" },
			],
		}
	},
	watch: {
		'$store.company'() {
			this.fetchPublishedApps()
		}
	},
	methods: {
		editApp(app) {
			this.$refs.appsToolbar.openPublishModalForEdit(app)
		},
		refreshPublishedData() {
			this.fetchPublishedApps()
			this.fetchCompanyData(false,["AddonApp"])
		},
		fetchPublishedApps() {
			let vm = this

			let params = {
				include: ["AddonAppInstalled",{model:"User",fields:["id","slug","first_name","last_name"]}],
				filters: [
					["publisher_user_id",this.$store.userDetails.id]
				]
			}

			this.spinner(true)

			this.getJSON("AddonApp/get",params,true).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.publishedApps = response.data.map(app => {
						let isPublic = app.is_public == 1 || app.is_public === true || app.is_public === "1"
						return Object.assign({}, app, {
							is_public: isPublic ? 1 : 0,
							publish_date_label: app.publish_date
								? vm.moment.utc(app.publish_date).local().format("MMM D, YYYY")
								: ""
						})
					})
				}
			})
		}
	},
	created() {
		this.fetchPublishedApps()
	}
}
</script>
